module.exports = __webpack_public_path__ + "static/media/gettyImages.02a48584.png";